import { Button } from '@susu/ui/components'

import { getCustomerServiceUrl } from '../../config/api.config'
import { useLabel } from '../../i18n'
import { withNodes } from '../../utils/withNodes'

interface OrderNoticeProps {
  title: string
  body: string
  actionLabel: string
  onAction: () => void
  isActionPending?: boolean
}

export function OrderNotice({
  title,
  body,
  actionLabel,
  onAction,
  isActionPending,
}: Readonly<OrderNoticeProps>) {
  const t = useLabel()

  return (
    <div className="mx-auto flex w-full flex-col items-center px-16 pt-40 pb-80 text-center md:max-w-[522px] md:pt-80 md:pb-120 lg:mx-0 lg:items-start lg:px-0 lg:text-left">
      <div role="status" className="flex max-w-[326px] flex-col gap-8">
        <h2 className="text-xl leading-xl font-medium tracking-heading text-balance text-text">
          {title}
        </h2>
        <p className="text-sm leading-sm font-light text-text">{body}</p>
      </div>
      <Button
        variant="filled"
        size="l"
        className="mt-32 w-[220px]"
        onClick={onAction}
        loading={isActionPending}
      >
        {actionLabel}
      </Button>
      <p className="mt-24 text-sm leading-sm font-light text-text">
        {withNodes(t('orderList.error.help'), {
          customerService: (
            <a href={getCustomerServiceUrl()} className="underline">
              {t('orderList.faq.link.customerService')}
            </a>
          ),
        })}
      </p>
    </div>
  )
}
